import * as React from 'react'
import { Flex, Box } from 'grid-styled'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import Hero from '../../components/Hero'
import Button from '../../components/Button'
import BackgroundSection from '../../components/BackgroundSection'
import MainLayout from '../../components/Layout'
import { AboutContact } from '..'
import Testimonials from '../../components/Testimonials'
import {
  SportswearImages,
  StyledTabs,
  StyledTabList,
  MoreSports,
  StyledTab,
  Content
} from '../../components/procedures'
import { TabPanel } from 'react-tabs'
import { netballTestimonials } from '../testimonials'

const content = {
  subtitle: `Trusted, Experienced & Ethical. Boutique plastic surgery on Sydney's north shore.`,
  title: 'Corporate'
}

export default ({ data }) => (
  <MainLayout header="light">
    <Helmet>
      <title>{content.title} - Custom Workwear - GFit</title>
      
    </Helmet>

    <Hero
      pngImage={true}
      bgImage={data.netball.childImageSharp}
      height="400px"
      noForm={true}
    />

    <Content>
      <h2>
        Workwear - <i>{content.title}</i>
      </h2>
      <span>
        Take a look below to see some of our previous{' '}
        {content.title.toLowerCase()} designs.
      </span>

      <p>
        Helping to create strong company brand awareness and having your staff
        looking sharp is always at the forefront when the GFIT designers put
        your corporate design concepts together.
      </p>
      <p>
        GFIT offers a massive range of corporate and company branded clothing
        and merchandise across all industries, Weather you are in the office all
        day or out on the road we have you covered. All the latest fashions and
        designs for both Women and Men are all at your fingertips. The GFIT
        embroidery and screen print team take care of all your company logos and
        any additional decoration.
      </p>
      <p>
        We pride ourselves on 7 days delivery time on all corporate apparel and
        merchandise orders.
      </p>
      <p>
        Keeping your company brand awareness strong and your staff looking sharp
        is always at the forefront when the GFIT designers put your corporate
        design concepts together.
      </p>

      <p>Call our team today to discuss how easy this can be.</p>

      <a href="http://www.aussiepacific.com.au/mens/ap-business">
        <Button inverted={true}>
          See the full range of corporate clothing!
        </Button>
      </a>
    </Content>

    <Content>
      <h2>Corporate Shirts</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.allFile.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Content>
      <h2>Corporate Trousers</h2>
    </Content>
    <SportswearImages>
      <div>
        {data.trousers.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Content>
      <h2>Corporate Blouses &amp; Dresses</h2>
    </Content>
    <SportswearImages>
      <div>
        {data.dresses.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Hero bgImage={data.sportsBreak.childImageSharp} height="750px">
      <h1>Do you have questions?</h1>
      <p>
        Call 0418 981 023 or please complete the enquiry form to contact us
        today and find out how we can help.
      </p>
      <Flex>
        <Button color={'#fff'} small={true} outline={true}>
          Contact Us
        </Button>
      </Flex>
    </Hero>

    <Testimonials testimonials={netballTestimonials} />

    <Box pb={5} pt={4}>
      <Flex my={4} justifyContent="center">
        <h2>Looking for another sport?</h2>
      </Flex>
      <MoreSports>
        {data.sports.edges.map(
          (image, i) =>
            image.node.childImageSharp && (
              <figure>
                <Link to={`/sport/${sportNames[i]}`}>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </Link>
              </figure>
            )
        )}
      </MoreSports>
    </Box>

    <AboutContact data={data} />
  </MainLayout>
)
const sportNames = [
  'cricket',
  'hockey',
  'soccer',
  'netball',
  'touch',
  'basketball',
  'rugby-league',
  'afl',
  'hi-vis',
  'rugby-union',
  'corporate',
  'baseball',
  'schools'
]

export const query = graphql`
  query CorporateQuery {
    dresses: allFile(filter: { relativeDirectory: { eq: "corporate-dress" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    trousers: allFile(
      filter: { relativeDirectory: { eq: "corporate-pants" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    allFile(filter: { relativeDirectory: { eq: "corporate" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }

    sports: allFile(filter: { relativeDirectory: { eq: "headers" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    netball: file(relativePath: { eq: "headers/corporate.png" }) {
      childImageSharp {
        fluid(maxWidth: 3000, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    otherBreast: file(relativePath: { eq: "woods-woman.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implant: file(relativePath: { eq: "implant-place.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantType: file(relativePath: { eq: "implant-type.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantType2: file(relativePath: { eq: "cut-smooth-implant.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantProfile: file(relativePath: { eq: "profile.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    drSellars: file(relativePath: { eq: "about-gfit.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    sportsBreak: file(relativePath: { eq: "sports-break.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
